import React, { Component } from "react";
import PropTypes from "prop-types";
import { VelocityComponent } from "velocity-react";
import PrimaryButton from "../Buttons/PrimaryButton";
import SelectPlayerButton from "../Buttons/SelectPlayerButton";
import SelectTagButton from "../Buttons/SelectTagButton";
import clipBedge from "../../assets/imgs/clip_bedge-07.png";
import Loader from "../Loaders/Loader";
import VideoInfoBoxTitle from "./VideoInfoBoxTitle";
import createDurationFromSeconds from "../../utils/createDurationFromSeconds";

require("velocity-animate");
require("velocity-animate/velocity.ui");

class VideoInfoBox extends Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
  }

  state = {
    hover: false,
    clicked: false
  };

  componentDidMount = () => {
    setTimeout(() => {
      if (this.videoRef && this.videoRef.current) {
        this.videoRef.current.pause();
        this.videoRef.current.currentTime = 0;
      }
    }, 1000);
  };


  getVideoSeekTime = () => {
    const { video } = this.props;

    if (video.seekTime) {
      return createDurationFromSeconds(video.seekTime);
    }

    return null;
  };

  // getDurationAndSeekTime = () => {
  //   const duration = this.getVideoDuration();
  //   const seekTime = this.getVideoSeekTime();
  //   return seekTime ? `${duration} (${seekTime})` : `${duration}`;
  // };

  handleAddRemove = e => {
    e.stopPropagation();
    this.setState(prevState => ({
      clicked: !prevState.clicked
    }));
    if (this.props.onAdd) {
      this.props.onAdd(this.props.video);
    }
  };

  handleMouseOver = () => {
    this.setState({ hover: true });
    //this.videoRef.current.play();
  };

  handleMouseOut = () => {
    this.setState({ hover: false });
    //this.videoRef.current.pause();
    // this.videoRef.current.currentTime = 0;
  };

  handleOnClick = () => {
    if (this.props.onClick) {
      this.props.onClick(this.props.video);
    }
  };

  setDisplayTaggedPlayers = () => {
    const {
      video: { tagedUsers, clipTaggedPlayers }
    } = this.props;
    const displayTaggedPlayer = [...tagedUsers];
    if (clipTaggedPlayers) {
      clipTaggedPlayers.map(player => {
        const index = tagedUsers.findIndex(
          taggedUser => taggedUser._id === player._id
        );
        if (index === -1) {
          displayTaggedPlayer.push(player);
        }
      });
    }

    return displayTaggedPlayer;
  };

  render() {
    const { video, hasClipBedge } = this.props;
    const displayTaggedPlayer = this.setDisplayTaggedPlayers();
    const displayTaggedPlayerList = displayTaggedPlayer.map(player => (
      <SelectPlayerButton
        key={player.id}
        disabled
        isSelected
        player={player}
        size="small"
      />
    ));
    const tagsList = video.tags
      ? video.tags.map(tag => (
          <SelectTagButton
            key={tag.title}
            disabled
            isSelected
            size="small"
            tag={tag}
          />
        ))
      : [];

    const clipTags = video.clipTags
      ? video.clipTags.map(tag => (
          <SelectTagButton
            key={tag.title}
            disabled
            isSelected
            size="small"
            tag={tag}
          />
        ))
      : [];
    const addButtonStyle = {
      fontSize: "12px",
      height: "30px",
      width: "100px",
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%,-50%)",
      background: !this.props.isSelected ? "#F45530" : "#15c4ab",
      color: "white",
      border: "none",
      margin: 0,
      zIndex: 2
    };

    return (
      <div
        className="videoInfoBox__container"
        data-testid="video-infobox"
        onMouseOver={this.handleMouseOver}
        onMouseLeave={this.handleMouseOut}
        onClick={
          video.status === ("IN_PROCESS" || "ON_EDIT")
            ? null
            : this.handleOnClick
        }
        style={this.props.style}
      >
        {hasClipBedge &&
          video.videoContainer &&
          video.status &&
          video.status !== "IN_PROCESS" && (
            <img className="videoInfoBox__clip-bedge" src={clipBedge} />
          )}
        {video.status &&
          video.status === ("IN_PROCESS" || "ON_EDIT") && (
            <div className="videoInfoBox__in-proccss-box">
              <Loader type="bars" />
              Processing Clip...
            </div>
          )}
        {this.state.hover ? (
          <div className="videoInfoBox__hover-overlay" />
        ) : null}
        <div className="videoInfoBox__img-container">
          <VelocityComponent
            animation={
              this.props.isSelected ? "transition.fadeIn" : "transition.fadeOut"
            }
            duration={200}
          >
            <div className="videoInfoBox__clicked-container">
              <div className="videoInfoBox__clicked-overlay" />
              <div className="videoInfoBox__selected-image">
                <div className="svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="140"
                    height="140"
                    viewBox="-263.5 236.5 26 26"
                  >
                    <g className="svg-success">
                      <circle cx="-250.5" cy="249.5" r="12" />
                      <path d="M-256.46 249.65l3.9 3.74 8.02-7.8" />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </VelocityComponent>
          <img src={video.thumbnailUri}  className="videoInfoBox__video-preview" />
          {video.status !== "IN_PROCESS" && (
            <div className="videoInfoBox__video-info">
              {tagsList}
              {clipTags}
              {displayTaggedPlayerList}
            </div>
          )}
        </div>
        <div className="videoInfoBox__title-container">
          {!video.status || (video.status && video.status !== "IN_PROCESS") ? (
            <VideoInfoBoxTitle
              sender={video.sender}
              title={this.getVideoSeekTime()}
              videoComment={video.title}
              // hasCommentIcon={!!video.title}
            />
          ) : null}
          {this.props.hasAddButton && this.state.hover ? (
            <PrimaryButton
              style={addButtonStyle}
              onClick={this.handleAddRemove}
            >
              {this.props.isSelected ? "REMOVE" : "ADD TO CLIP"}
            </PrimaryButton>
          ) : null}
        </div>
      </div>
    );
  }
}

VideoInfoBox.propTypes = {
  hasAddButton: PropTypes.bool,
  hasClipBedge: PropTypes.bool,
  /** show selected style or not */
  isSelected: PropTypes.bool,
  /** function to call when click on the ADD button in video box   */
  onAdd: PropTypes.func,
  /** function to call when click on video box in the grid */
  onClick: PropTypes.func,
  /** video to display on the video box */
  video: PropTypes.object.isRequired
};

VideoInfoBox.defaultProps = {
  hasAddButton: true,
  hasClipBedge: false,
  isSelected: true,
  onAdd: () => {},
  onClick: () => {}
};

export default VideoInfoBox;
